import Vue from 'vue'
import get from 'lodash/get'
import branch from 'branch-sdk'
import 'typeface-overpass'
import 'typeface-open-sans'
import 'typeface-roboto'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import { Branch, User } from '@/types'
import eventTracker from '@/utils/eventTracker'
import pick from 'lodash/pick'
import '@/router/guards'
import '@/styles/index.scss'
import '@assets/images/icons'

Vue.config.productionTip = false
Vue.config.errorHandler = (error, vm, info) => {
  const details = {
    error: pick(error, ['name', 'message', 'stack']),
    info,
    route: pick(vm.$route, ['path', 'fullPath', 'query', 'params', 'name'])
  }
  console.error(error, info, vm)
  eventTracker.track('Error Vue', details)
}
window.onerror = function (message, source, lineno, colno, error) {
  if (error) {
    console.log(error.stack)
    eventTracker.track('Error Uncaught', {
      message,
      source,
      lineno,
      colno
    })
  }
  return true
}

const init = async () => {
  // Check availability of the Branch.io, not proceed if blocked
  if (await store.dispatch('app/TestBranchAvailability')) {
    // Initialize Branch
    const branchKey = /^dev|stage$/.test(process.env.VUE_APP_ENV || '')
      ? 'key_test_ghHwQQQvgm23mY2TBjJFJkieEyjLRWxB'
      : 'key_live_mjRBVIKvnd7Yn31HyeMEtnlkEqcNG9Fl'
    // --
    const debugUsername = process.env.VUE_APP_ML_USERNAME
    const debugPassword = process.env.VUE_APP_ML_PASSWORD
    // Retrieve credentials from deep link
    const credentials = await new Promise<User.API.ReqRes.Login.Credentials | null>(
      resolve => {
        branch.init(
          branchKey,
          (error: Error, data: Branch.BranchData) => {
            const username = error ? null : get(data, 'data_parsed.username', debugUsername)
            const password = error ? null : get(data, 'data_parsed.password', debugPassword)
            if (!error && location.search) {
              eventTracker.track('MagicLinkClicked', { linkCode: location.href })
            }
            resolve(
              username && password
                ? { username, password }
                : null
            )
          }
        )
      }
    )
    // Store credentials
    store.dispatch('user/SetCredentials', credentials)
  }
  // Initialize Vue application
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

init()
